import MovimientosBancariosComponent from '@/components/bancos/MovimientosBancariosComponent'
import MovimientosBancariosFormComponent from '@/components/bancos/MovimientosBancariosFormComponent'
import EstadoDeCuentaRptComponent from '@/components/bancos/reportes/EstadoDeCuentaRptComponent'

import ConciliacionBancariaComponent from '@/components/bancos/conciliacion_bancaria/ConciliacionBancariaComponent'



export default [
    {
        path: '/bancos/movimiento-bancario/nuevo',
        name: 'bancos-movimiento-bancario-nuevo',
        component: MovimientosBancariosFormComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/bancos/movimiento-bancario/editar/:id/',
        name: 'bancos-movimiento-bancario-editar',
        component: MovimientosBancariosFormComponent,
        meta: {
            requiresAuth: true,
            permission: '',
        }
    },
    {
        path: '/bancos/movimiento-bancario/',
        name: 'bancos-movimiento-bancario',
        component: MovimientosBancariosComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/bancos/estado-cuenta/',
        name: 'bancos-estado-cuenta',
        component: EstadoDeCuentaRptComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/bancos/movimiento-bancario/editar/:id/',
        name: 'bancos-movimiento-bancario-editar',
        component: MovimientosBancariosFormComponent,
        meta: {
            requiresAuth: true,
            permission: '',
        }
    },
    {
        path: '/bancos/movimiento-bancario/',
        name: 'bancos-movimiento-bancario',
        component: MovimientosBancariosComponent,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/bancos/conciliacion-bancaria/',
        name: 'bancos-conciliacion-bancaria',
        component: ConciliacionBancariaComponent,
        meta: {
            requiresAuth: true
        }
    },
]